import { GitHubAction, GitHubWebhookEvent } from '../github';
import { TriggerKey } from '../userCommunicationAgent';

export const GITHUB_TRIGGER_KEYS = [TriggerKey.GITHUB_EVENT_MATCH];

export interface GitHubEventFilter {
  event: GitHubWebhookEvent;
  actions?: GitHubAction[]; // empty/absent = all actions of this event
  // `release` events only: glob patterns matched against the release tag, where
  // `*` is the only wildcard (e.g. `prod-all-*`). Empty/absent = any tag.
  refPatterns?: string[];
}

// One connected GitHub App installation, optionally narrowed to some of its
// repositories. Mirrors SlackNewMessageWorkspaceScope: an empty `repositories`
// means every repository in THIS installation, including ones created later —
// which is the case a flat list of fullNames cannot express.
export interface GitHubInstallationScope {
  installationId: string;
  repositories?: string[];
}

export interface GitHubEventMatchTriggerConfig {
  // Empty/absent = every installation. Scopes are OR-ed: a communication
  // matches when any one of them admits it.
  installations?: GitHubInstallationScope[];
  // Flat shape persisted before `installations`. Still honoured, and still
  // what the template catalogue emits, since a template knows repository
  // fullNames but never an installation id. OR-ed with `installations`.
  installationId?: string;
  repositories?: string[];
  eventFilters?: GitHubEventFilter[]; // empty/absent = all events + all actions
}
